import { render, staticRenderFns } from "./ModalDownloadClaim.vue?vue&type=template&id=da68d7e8&"
import script from "./ModalDownloadClaim.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports